/* とよなかマルシェ テーマ共通の動き（自動再生・ポップアップは使わない）
   メニュー開閉／地図を押してから読み込む／本文の写真をまとめて拡大表示／リンクのコピー／商品の写真と数量 */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  // ---- メニュー ----
  const menuBtn = $('.menu-btn');
  const drawer = $('#drawer');
  if (menuBtn && drawer) {
    const label = $('.btn-text', menuBtn);
    const set = (open) => {
      menuBtn.setAttribute('aria-expanded', String(open));
      drawer.hidden = !open;
      if (label) label.textContent = open ? '閉じる' : 'メニュー';
    };
    menuBtn.addEventListener('click', () => set(menuBtn.getAttribute('aria-expanded') !== 'true'));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) { set(false); menuBtn.focus(); }
    });
    window.addEventListener('resize', () => { if (window.innerWidth >= 960 && !drawer.hidden) set(false); });
  }

  // ---- お知らせ（コピーしました など） ----
  function toast(msg) {
    const t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 2400);
  }

  // ---- 端末の共有機能（スマホなど、使える端末だけボタンを出す） ----
  $$('[data-share]').forEach((b) => {
    if (!navigator.share) return;
    b.hidden = false;
    b.addEventListener('click', () => navigator.share({ title: b.dataset.title, url: b.dataset.url }).catch(() => {}));
  });

  // ---- スマホの電話・地図の帯: 「出かける前に」を通り過ぎ、店舗情報の表が見えていない間だけ出す ----
  const bar = $('[data-actionbar]');
  const quickBox = $('.quick');
  const shopCard = $('#shop');
  if (bar && quickBox && 'IntersectionObserver' in window) {
    let pastQuick = false, shopVisible = false;
    const sync = () => {
      const show = pastQuick && !shopVisible;
      bar.hidden = !show;
      document.body.classList.toggle('has-actionbar', show);
    };
    new IntersectionObserver(([e]) => { pastQuick = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(quickBox);
    if (shopCard) new IntersectionObserver(([e]) => { shopVisible = e.isIntersecting; sync(); }).observe(shopCard);
  }

  // ---- お問い合わせ: 記事から来たとき（?article=店名）は、対象の記事と用件を入れておく ----
  const art = new URLSearchParams(location.search).get('article');
  const artInput = $('#c-article');
  if (art && artInput && !artInput.value) {
    artInput.value = art;
    const kind = $('#c-kind');
    if (kind) kind.selectedIndex = 0;
  }

  // ---- リンクをコピー ----
  $$('[data-copy]').forEach((b) => b.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(b.dataset.copy); toast('リンクをコピーしました'); }
    catch (e) { window.prompt('このリンクをコピーしてください', b.dataset.copy); }
  }));

  // ---- 地図: 押してから読み込む ----
  $$('iframe[data-tm-map]').forEach((f) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'map-facade';
    btn.innerHTML = '<span><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-6.5-5.8-6.5-11a6.5 6.5 0 0 1 13 0c0 5.2-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/></svg>地図を表示する（Googleマップ）</span>';
    btn.addEventListener('click', () => {
      const frame = document.createElement('iframe');
      frame.src = f.dataset.src;
      frame.className = 'map-frame';
      frame.title = '店の場所の地図';
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.allowFullscreen = true;
      btn.replaceWith(frame);
      frame.focus();
    });
    // 地図だけの段落なら段落ごと置き換える
    const p = f.parentElement;
    if (p && p.tagName === 'P' && p.children.length === 1 && p.textContent.trim() === '') p.replaceWith(btn); else f.replaceWith(btn);
  });

  // ---- 特集・まとめ（1列の長い記事）: 見出しから目次を作る。PCは右の列に追従、スマホは本文の頭に折りたたみ ----
  const single = $('.a-layout.is-single');
  const singleProse = single && $('.prose', single);
  if (singleProse) {
    // 見出しの末尾の「営業中」「確認中」「移転」「閉店」（特集の原稿の書き方）を、色の付いた札にする
    const PILL = { 営業中: 'pill-open', 確認中: 'pill-pending', 移転: 'pill-moved', 閉店: 'pill-closed' };
    $$(':scope > h3', singleProse).forEach((h) => {
      let last = h.lastChild;
      while (last && last.nodeType === 3 && !last.textContent.trim()) last = last.previousSibling;
      if (last && last.nodeType === 1 && last.tagName === 'SPAN' && /^(営業中|確認中|移転|閉店)(（[^）]*）)?$/.test(last.textContent.trim())) {
        const st = last.textContent.trim();
        last.className = `pill ${PILL[st.slice(0, st.indexOf('（') > 0 ? st.indexOf('（') : st.length)]}`;
        last.textContent = st;
        return;
      }
      if (!last || last.nodeType !== 3) return;
      const m = /[\s　]*(営業中|確認中|移転|閉店)(（[^）]*）)?\s*$/.exec(last.textContent);
      if (!m) return;
      last.textContent = last.textContent.slice(0, m.index);
      const sp = document.createElement('span');
      sp.className = `pill ${PILL[m[1]]}`;
      sp.textContent = m[1] + (m[2] || '');
      h.appendChild(document.createTextNode(' '));
      h.appendChild(sp);
    });
    const hs = $$(':scope > h2', singleProse).filter((h) => h.textContent.trim());
    let nShops = 0;
    if (hs.length >= 3) {
      const txt = (el) => el.textContent.trim().replace(/[<>&]/g, '');
      const items = hs.map((h, i) => {
        if (!h.id) h.id = `sec-${i + 1}`;
        // その見出しの下にある店名（h3）も、入れ子の目次にする
        const subs = [];
        for (let n = h.nextElementSibling; n && n.tagName !== 'H2'; n = n.nextElementSibling) {
          if (n.tagName === 'H3' && n.textContent.trim()) {
            if (!n.id) n.id = `${h.id}-${subs.length + 1}`;
            // 目次には店名の本体だけ（読み・地名の（）と状態の札は本文の見出しで）
            let name = Array.from(n.childNodes).filter((c) => !(c.classList && c.classList.contains('pill'))).map((c) => c.textContent).join('').trim();
            if (name.indexOf('（') > 0) name = name.slice(0, name.indexOf('（')).trim();
            subs.push(`<li><a href="#${n.id}">${name.replace(/[<>&]/g, '')}</a></li>`);
            nShops += 1;
          }
        }
        return `<li><a href="#${h.id}">${txt(h)}</a>${subs.length ? `<ol>${subs.join('')}</ol>` : ''}</li>`;
      }).join('');
      // 特集はサーバー側で右の列を空けてある（あとから列を作ると本文の幅が変わり、画面がずれるため）
      let pc = $('[data-toc]', single);
      if (!pc) {
        pc = document.createElement('aside');
        pc.className = 'toc-aside';
        pc.setAttribute('aria-label', 'この記事の目次');
        single.appendChild(pc);
        single.classList.add('has-toc');
      }
      pc.innerHTML = `<nav class="toc-box"><p class="h">この記事の目次</p><ol>${items}</ol></nav>`;
      // スマホ: 本文の頭に用意した置き場所に入れる（閉じた状態なので高さは変わらない）
      const label = `この記事の目次（${hs.length}区分${nShops ? `・${nShops}店` : ''}）`;
      let sp = $('[data-toc-inline]', singleProse);
      if (!sp) {
        sp = document.createElement('details');
        sp.className = 'toc-box toc-inline';
        singleProse.insertBefore(sp, hs[0]);
      }
      sp.innerHTML = `<summary>${label}</summary><ol>${items}</ol>`;
      // 今読んでいる区分を目次で強調する（PC）
      if ('IntersectionObserver' in window) {
        const links = $$('a', pc);
        const io2 = new IntersectionObserver((ents) => {
          ents.forEach((e) => {
            if (!e.isIntersecting) return;
            links.forEach((a) => a.removeAttribute('aria-current'));
            const a = links.find((l) => l.getAttribute('href') === `#${e.target.id}`);
            if (a) a.setAttribute('aria-current', 'true');
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        hs.forEach((h) => io2.observe(h));
      }
    } else {
      const pc = $('[data-toc]', single);
      if (pc) { pc.remove(); single.classList.remove('has-toc'); }
      const sp = $('[data-toc-inline]', singleProse);
      if (sp) sp.remove();
    }
  }

  // ---- 本文の写真: 押すと拡大（まとめ表示はサーバー側の snippets/prose-html で済んでいる） ----
  const prose = $('.prose');
  if (prose) {
    // 代替テキストのない古い写真（写真のまとめ以外の形のもの）に、記事名から説明を付ける
    const fb = prose.dataset.altFallback;
    if (fb) $$('img:not([alt])', prose).forEach((im) => im.setAttribute('alt', fb));
    const all = $$('.gallery .gi', prose);
    if (all.length && 'HTMLDialogElement' in window) {
      const dlg = document.createElement('dialog');
      dlg.className = 'lightbox';
      dlg.setAttribute('aria-label', '写真の拡大表示');
      dlg.innerHTML = '<figure><img alt=""><figcaption></figcaption></figure>'
        + '<button type="button" class="icon-btn lb-close" aria-label="閉じる"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
        + '<button type="button" class="icon-btn lb-nav lb-prev" aria-label="前の写真"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>'
        + '<button type="button" class="icon-btn lb-nav lb-next" aria-label="次の写真"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
      document.body.appendChild(dlg);
      const big = $('img', dlg), cap = $('figcaption', dlg);
      let i = 0, opener = null;
      const show = (n) => {
        i = (n + all.length) % all.length;
        const im = $('img', all[i]);
        big.src = all[i].dataset.full;
        big.alt = im.alt || '';
        cap.textContent = `${im.alt || ''}（${i + 1}/${all.length}）`;
        $$('.lb-nav', dlg).forEach((b) => { b.hidden = all.length < 2; });
      };
      all.forEach((b, n) => b.addEventListener('click', () => { opener = b; show(n); dlg.showModal(); }));
      $('.lb-close', dlg).addEventListener('click', () => dlg.close());
      $('.lb-prev', dlg).addEventListener('click', () => show(i - 1));
      $('.lb-next', dlg).addEventListener('click', () => show(i + 1));
      dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.tagName === 'FIGURE') dlg.close(); });
      dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') show(i - 1);
        if (e.key === 'ArrowRight') show(i + 1);
      });
      dlg.addEventListener('close', () => { big.removeAttribute('src'); if (opener) opener.focus(); });
    }
  }

  // ---- 商品: 写真の切り替え ----
  const main = $('.pdp-media .main img');
  $$('[data-pdp-thumb]').forEach((b) => b.addEventListener('click', () => {
    if (!main) return;
    main.src = b.dataset.src;
    main.srcset = b.dataset.srcset || '';
    main.alt = b.dataset.alt || '';
    $$('[data-pdp-thumb]').forEach((x) => x.setAttribute('aria-current', String(x === b)));
  }));

  // ---- 数量の −／＋（カートは描き直すので、ページ全体で受ける） ----
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty] button[data-step]');
    if (!b) return;
    const input = $('input', b.closest('[data-qty]'));
    if (!input) return;
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(b.dataset.step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---- カート（Shopify のカートそのものを使う。表示だけのカートは作らない） ----
  // URL はテーマが出したリンク（routes.cart_url）から作る: /cart.js・/cart/add.js・/cart/change.js
  const cartLink = $('[data-cart-link]');
  const cartUrl = ((cartLink && cartLink.getAttribute('href')) || '/cart').replace(/\/$/, '');
  const MSG_NET = '通信できませんでした。電波の良いところで、もう一度お試しください。';

  // ヘッダーのカートの点数・メニューの「カートを見る」を書き換える
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
    $$('[data-cart-link]').forEach((a) => a.setAttribute('aria-label', `カート（${n}点）`));
    $$('[data-cart-summary]').forEach((el) => { el.textContent = n ? `${n}点` : '空です'; });
  }
  async function getCart() {
    const r = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart ${r.status}`);
    const c = await r.json();
    setCount(c.item_count);
    return c;
  }
  // 戻るボタンで、記憶していたページに戻ったときは点数を取り直す（ほかのページで入れた分を反映）
  window.addEventListener('pageshow', (e) => { if (e.persisted) getCart().catch(() => {}); });
  const currentCount = () => { const el = $('[data-cart-count]'); return el && !el.hidden ? Number(el.textContent) || 0 : 0; };
  // 失敗の知らせ: 在庫不足（422）は Shopify の断りの文（日本語のとき）を、それ以外は状態ごとに用意した文を出す
  async function reason(r, stockMsg) {
    if (r.status === 422) {
      try {
        const j = await r.json();
        const d = (j.description || j.message || '').trim();
        if (d && /[぀-ヿ一-鿿]/.test(d)) return d;
      } catch (e) { /* 文がない */ }
      return stockMsg;
    }
    if (r.status === 429) return '混み合っているため、受け付けられませんでした。少し時間をおいて、もう一度お試しください。';
    if (r.status === 400 || r.status === 404) return 'カートの内容が変わっていたため、受け付けられませんでした。最新の内容をご確認ください。';
    return '受け付けられませんでした。時間をおいて、もう一度お試しください。';
  }

  // ---- 商品ページ: 種類を項目ごとに選ぶ・カートに入れる ----
  $$('form[data-product-form]').forEach((form) => {
    const btn = $('[data-add]', form);
    const label = $('[data-add-label]', form);
    const err = $('[data-add-error]', form);
    const live = $('[data-add-live]', form);
    const added = $('[data-added]', form);
    const addedText = $('[data-added-text]', form);
    const master = $('[data-variant-select]', form);
    const optsBox = $('[data-options]', form);
    const vjson = $('[data-variants]', form);
    const price = $('[data-pdp-price]');
    const compare = $('[data-pdp-compare]');
    let variants = [];
    try { variants = vjson ? JSON.parse(vjson.textContent) : []; } catch (e) { variants = []; }
    let current = null;
    let hasOpts = false;
    const showErr = (msg) => { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; };
    const resetBtn = () => {
      if (hasOpts && !current) { btn.disabled = true; label.textContent = 'この組み合わせはありません'; return; }
      const ok = !current || current.available;
      btn.disabled = !ok;
      label.textContent = ok ? 'カートに入れる' : 'この種類は売り切れ';
    };

    if (optsBox && master && variants.length) {
      // JavaScript があるときは、種類の一覧の代わりに項目ごとの選択を出す
      hasOpts = true;
      optsBox.hidden = false;
      const row = master.closest('[data-variant-row]');
      if (row) row.hidden = true;
      const sels = $$('[data-option]', optsBox);
      const find = (vals) => variants.find((x) => x.options.every((o, i) => o === vals[i]));
      const mark = () => sels.forEach((s, i) => Array.from(s.options).forEach((o) => {
        const vals = sels.map((x) => x.value);
        vals[i] = o.value;
        const v = find(vals);
        if (!o.dataset.base) o.dataset.base = o.textContent;
        o.textContent = !v ? `${o.dataset.base}（この組み合わせはありません）` : (v.available ? o.dataset.base : `${o.dataset.base}（売り切れ）`);
      }));
      const sync = (fromUser) => {
        current = find(sels.map((s) => s.value));
        mark();
        showErr('');
        if (added) added.hidden = true;
        if (current) {
          master.value = String(current.id);
          if (price) price.textContent = current.price;
          if (compare) { compare.textContent = current.compare || ''; compare.hidden = !current.compare; }
          if (fromUser) {
            const u = new URL(location.href);
            u.searchParams.set('variant', current.id);
            history.replaceState(history.state, '', u);
          }
        }
        resetBtn();
      };
      sels.forEach((s) => s.addEventListener('change', () => sync(true)));
      sync(false);
    }
    const qtyInput = $('input[name="quantity"]', form);
    if (qtyInput) qtyInput.addEventListener('change', () => { showErr(''); if (added) added.hidden = true; });

    // テイクアウト: 受け取り日は、最短の日以降で、受け取りできない曜日を除く（テーマ設定の値。ブラウザの確認では曜日まで見られないため）
    const pickup = $('[data-pickup]', form);
    const pickDate = pickup && $('[data-pickup-date]', pickup);
    const WD = '日月火水木金土';
    const pickupProblem = () => {
      if (!pickDate) return '';
      const v = pickDate.value;
      const min = pickup.dataset.min || '';
      const closed = pickup.dataset.closed || '';
      if (!v) return '受け取り日を選んでください。';
      if (min && v < min) return `受け取り日は ${min.replace(/-/g, '/')} 以降を選んでください。`;
      const wd = WD[new Date(`${v}T00:00:00`).getDay()];
      if (closed && closed.includes(wd)) return `${wd}曜日は受け取りできません（受け取りできない曜日: ${closed}）。`;
      return '';
    };
    if (pickDate) pickDate.addEventListener('change', () => { if (added) added.hidden = true; showErr(pickupProblem()); });

    form.addEventListener('submit', async (e) => {
      const pp = pickupProblem();
      if (pp) { e.preventDefault(); showErr(pp); pickDate.focus(); return; }
      if (!window.fetch || !window.FormData) return; // 古い端末は、ふつうのフォームとしてカートのページへ
      e.preventDefault();
      if (btn.disabled) return;
      showErr('');
      if (added) added.hidden = true;
      const q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (qtyInput) qtyInput.value = q;
      const prev = currentCount();
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      label.textContent = 'カートに入れています…';
      const done = (n) => {
        const msg = n ? `カートに入れました（カートの商品は ${n}点）。` : 'カートに入れました。';
        if (addedText) addedText.textContent = msg;
        if (live) live.textContent = msg;
        if (added) added.hidden = false;
      };
      try {
        const r = await fetch(`${form.getAttribute('action')}.js`, {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin',
        });
        if (!r.ok) {
          showErr(await reason(r, '在庫が足りないため、カートに入れられませんでした。数量を減らすか、ほかの種類をお選びください。'));
          getCart().catch(() => {});
          return;
        }
        let n = null;
        try { n = (await getCart()).item_count; } catch (e2) { /* 点数は次のページで反映 */ }
        done(n);
      } catch (e3) {
        // 通信が途中で切れても、カートには入っていることがある。カートを確かめ、入っていれば入れた知らせにする（二重に入れないように）
        try {
          const c = await getCart();
          if (c.item_count > prev) { done(c.item_count); return; }
        } catch (e4) { /* 確かめられない */ }
        showErr(`${MSG_NET}（もう一度押す前に、ヘッダーのカートの点数をご確認ください）`);
      } finally {
        btn.removeAttribute('aria-busy');
        resetBtn();
      }
    });
  });

  // ---- カートのページ: 数量の変更・削除をその場で反映 ----
  const cartRoot = $('[data-cart]');
  if (cartRoot) {
    cartRoot.classList.add('cart-js'); // ここまで動いたときだけ「数量を更新する」ボタンを隠す（動かないときはボタンで更新できる）
    const sid = cartRoot.dataset.sectionId;
    const status = $('[data-cart-status]');
    const pending = new Map(); // 行の key → 送る数量（続けて押した分をまとめる）
    let timer = null;
    let chain = Promise.resolve(); // 送るのは1本ずつ順番に
    let seq = 0;
    // 読み上げは、描き直しが終わってから（同じ文でも読まれるよう、いったん空にする）
    const say = (m) => { if (!status) return; status.textContent = ''; setTimeout(() => { status.textContent = m; }, 60); };
    // このセクションだけを Shopify に描き直してもらい、差し替える。
    // ご要望欄は、入力中の文字・フォーカス・カーソルの位置を残す。まだ送っていない数量は、入力欄に書き戻す
    async function rerender() {
      const r = await fetch(`${cartUrl}?sections=${encodeURIComponent(sid)}`, { credentials: 'same-origin' });
      if (!r.ok) throw new Error(`render ${r.status}`);
      const j = await r.json();
      const fresh = $('[data-cart]', new DOMParser().parseFromString(j[sid] || '', 'text/html'));
      if (!fresh) throw new Error('render');
      const note = $('#cart-note', cartRoot);
      const noteVal = note ? note.value : null;
      const noteFocus = note && document.activeElement === note ? [note.selectionStart, note.selectionEnd] : null;
      cartRoot.innerHTML = fresh.innerHTML;
      const note2 = $('#cart-note', cartRoot);
      if (note2 && noteVal !== null) note2.value = noteVal;
      if (note2 && noteFocus) { note2.focus({ preventScroll: true }); note2.setSelectionRange(noteFocus[0], noteFocus[1]); }
      pending.forEach((q, k) => {
        const li = rows().find((x) => x.dataset.key === k);
        const inp = li && $('[data-line-qty]', li);
        if (inp) inp.value = q;
      });
    }
    const lineMsg = (key, m) => {
      const li = $$('[data-key]', cartRoot).find((x) => x.dataset.key === key);
      const p = li && $('[data-line-msg]', li);
      if (p) { p.textContent = m; p.hidden = false; }
    };
    // 押していた操作（行の key と、どのボタンか）を覚え、描き直したあとも同じ場所にフォーカスを戻す
    const rows = () => $$('[data-cart-items] [data-key]', cartRoot);
    function rememberFocus() {
      const a = document.activeElement;
      const li = a && cartRoot.contains(a) ? a.closest('[data-key]') : null;
      if (!li) return null;
      let sel = null;
      if (a.matches('[data-line-qty]')) sel = '[data-line-qty]';
      else if (a.matches('[data-line-remove]')) sel = '[data-line-remove]';
      else if (a.dataset.step) sel = `button[data-step="${a.dataset.step}"]`;
      return { key: li.dataset.key, sel, idx: rows().indexOf(li) };
    }
    function restoreFocus(f) {
      // ほかの場所（ご要望欄など）を操作中なら動かさない。描き直しでフォーカスが失われたときだけ戻す
      const a = document.activeElement;
      if (!f || (a && a !== document.body && a.isConnected)) return;
      const li = rows().find((x) => x.dataset.key === f.key);
      let el = li && f.sel ? $(f.sel, li) : null;
      if (!el) { // 行が消えたとき（削除）は、次の行の数量、なければ見出し
        const rs = rows();
        const next = rs[Math.min(f.idx, rs.length - 1)];
        el = (next && $('[data-line-qty]', next)) || $('[data-cart-h1]', cartRoot);
      }
      if (el) el.focus({ preventScroll: true });
    }
    // 失敗の知らせは、あとの送信に追い越されても捨てずにため、最後の描き直しのあとでまとめて出す
    let errors = []; // { key: 行の key（行が分からないときは null）, msg }
    async function send(updates, my, f) {
      cartRoot.setAttribute('aria-busy', 'true');
      const keys = Object.keys(updates);
      const lineKey = keys.length === 1 ? keys[0] : null; // まとめて送って断られたときは、どの行か分からない
      let msg = '';
      let ok = true;
      try {
        const r = await fetch(`${cartUrl}/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!r.ok) {
          ok = false;
          errors.push({ key: lineKey, msg: await reason(r, '在庫が足りないため、数量を変えられませんでした。') });
        } else {
          const c = await r.json();
          setCount(c.item_count);
          // 実際にカートに入った数量で知らせる（在庫で減らされたときは、その旨を行の下にも出す）
          keys.forEach((k) => {
            const it = c.items.find((x) => x.key === k);
            if (it && it.quantity < updates[k]) { ok = false; errors.push({ key: k, msg: `在庫の都合で、数量は${it.quantity}点までになりました。` }); }
          });
          const it = keys.length === 1 ? c.items.find((x) => x.key === keys[0]) : null;
          msg = keys.length > 1 ? 'カートの数量を変えました。' : (it ? `数量を${it.quantity}点にしました。` : '商品をカートから削除しました。');
          msg += c.item_count ? `カートの商品は${c.item_count}点です。` : 'カートは空になりました。';
        }
        if (my === seq) await rerender(); // あとの変更が控えているときは、最後の描き直しに任せる
      } catch (e) {
        ok = false;
        errors.push({ key: lineKey, msg: MSG_NET });
        try { if (my === seq) await rerender(); } catch (e2) { /* 表示はそのまま */ }
      } finally {
        cartRoot.removeAttribute('aria-busy');
      }
      if (my !== seq) return ok;
      if (errors.length) {
        errors.forEach((x) => { if (x.key) lineMsg(x.key, x.msg); });
        say(errors.map((x) => x.msg).filter((m, i, a) => a.indexOf(m) === i).join(''));
        errors = [];
      } else {
        const sub = $('[data-cart-total] .price', cartRoot);
        say(sub ? `${msg}小計は${sub.textContent.trim()}です。` : msg);
      }
      restoreFocus(f);
      return ok;
    }
    // まだ送っていない変更をまとめて送る。送った結果（すべて受け付けられたか）を返す
    function flush() {
      clearTimeout(timer);
      if (!pending.size) return chain.then(() => true);
      const updates = Object.fromEntries(pending);
      pending.clear();
      const my = ++seq;
      const f = rememberFocus();
      chain = chain.then(() => send(updates, my, f));
      return chain;
    }
    const queue = (key, qty, now) => {
      pending.set(key, qty);
      clearTimeout(timer);
      if (now) flush(); else timer = setTimeout(flush, 400);
    };
    cartRoot.addEventListener('change', (e) => {
      const inp = e.target.closest('[data-line-qty]');
      if (!inp) return;
      queue(inp.closest('[data-key]').dataset.key, Math.max(0, parseInt(inp.value, 10) || 0));
    });
    cartRoot.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-line-remove]');
      if (!rm || !window.fetch) return;
      e.preventDefault();
      queue(rm.closest('[data-key]').dataset.key, 0, true);
    });
    // 購入手続きへ進む前に、まだ送っていない数量の変更があれば送り終えてから進む。
    // 送った変更が受け付けられなかったとき（在庫不足・通信の失敗）は進まずに止め、知らせを読んでもらう
    cartRoot.addEventListener('submit', (e) => {
      if (!pending.size || e.submitter === undefined) return;
      e.preventDefault();
      const name = (e.submitter && e.submitter.name) || 'checkout';
      flush().then((ok) => {
        if (!ok) return;
        // 描き直しでボタンが新しくなるので、名前で探し直して押す
        const b = $(`button[name="${name}"]`, cartRoot);
        if (b && !b.disabled) b.click();
      });
    });
    // 戻るボタンでカートのページに戻ったときは、最新のカートで描き直す
    window.addEventListener('pageshow', (e) => { if (e.persisted) rerender().catch(() => {}); });
  }
})();
